// libs/core/src/lib/math/big-math.ts
var BigMath = class {
  constructor() {
    throw new Error("BigMath does not support instance creation. Use static methods: div, mul, add, sub, avr, pow, min, max.");
  }
  static from(number, decimals) {
    return BigInt(number * 10 ** decimals);
  }
  static div(numerator, denominator, numeratorDecimals, denominatorDecimals, resultDecimals = denominatorDecimals) {
    if (denominator === 0n) {
      throw new Error("Division by zero.");
    }
    if (numerator === 0n) {
      return 0n;
    }
    const scale = BigInt(10) ** BigInt(Math.max(numeratorDecimals, denominatorDecimals));
    numerator = numerator * (scale / BigInt(10) ** BigInt(numeratorDecimals));
    denominator = denominator * (scale / BigInt(10) ** BigInt(denominatorDecimals));
    const resultScale = BigInt(10) ** BigInt(resultDecimals);
    numerator = numerator * resultScale;
    return numerator / denominator;
  }
  static mul(valueA, valueB, valueADecimals, valueBDecimals, resultDecimals = valueBDecimals) {
    if (valueA === 0n || valueB === 0n) {
      return 0n;
    }
    const product = valueA * valueB;
    const totalDecimals = BigInt(valueADecimals + valueBDecimals);
    const scale = 10n ** totalDecimals;
    const resultScale = 10n ** BigInt(resultDecimals);
    return product * resultScale / scale;
  }
  static add(valueA, valueB, valueADecimals, valueBDecimals, resultDecimals = valueBDecimals) {
    const maxDecimals = Math.max(valueADecimals, valueBDecimals, resultDecimals);
    valueA = valueA * BigInt(10) ** BigInt(maxDecimals - valueADecimals);
    valueB = valueB * BigInt(10) ** BigInt(maxDecimals - valueBDecimals);
    const sum = valueA + valueB;
    if (resultDecimals < maxDecimals) {
      return sum / BigInt(10) ** BigInt(maxDecimals - resultDecimals);
    }
    return sum;
  }
  static sub(valueA, valueB, valueADecimals, valueBDecimals, resultDecimals = valueBDecimals) {
    const maxDecimals = Math.max(valueADecimals, valueBDecimals, resultDecimals);
    valueA = valueA * BigInt(10) ** BigInt(maxDecimals - valueADecimals);
    valueB = valueB * BigInt(10) ** BigInt(maxDecimals - valueBDecimals);
    const difference = valueA - valueB;
    if (resultDecimals < maxDecimals) {
      return difference / BigInt(10) ** BigInt(maxDecimals - resultDecimals);
    }
    return difference;
  }
  static avr(numbers, numbersDecimals, resultDecimals = numbersDecimals) {
    if (numbers.length === 0) {
      return 0n;
    }
    const scale = BigInt(10) ** BigInt(resultDecimals);
    const scaledNumbers = numbers.map((num) => num * scale / BigInt(10) ** BigInt(numbersDecimals));
    const sum = scaledNumbers.reduce((acc, curr) => acc + curr, BigInt(0));
    return sum / BigInt(numbers.length);
  }
  static pow(base, exponent, baseDecimals, resultDecimals = baseDecimals) {
    if (exponent < 0) {
      throw new Error("Negative exponents are not supported.");
    }
    if (exponent === 0) {
      return BigInt(10) ** BigInt(resultDecimals);
    }
    const factor = BigInt(10) ** BigInt(baseDecimals);
    const adjustedBase = base * factor;
    let result = adjustedBase ** BigInt(exponent);
    const resultScale = BigInt(10) ** BigInt(exponent * baseDecimals);
    result = result / resultScale;
    if (resultDecimals !== baseDecimals) {
      const scale = BigInt(10) ** BigInt(resultDecimals - baseDecimals);
      result = result * scale;
    }
    return result;
  }
  static min(...values) {
    let result = values[0];
    for (const value of values) {
      if (value < result) {
        result = value;
      }
    }
    return result;
  }
  static max(...values) {
    let result = values[0];
    for (const value of values) {
      if (value > result) {
        result = value;
      }
    }
    return result;
  }
  static calculatePercentage(value, percentage) {
    if (percentage < 0 || percentage > 100) {
      throw new Error("Percentage must be a number between 0 and 100");
    }
    const decimalPercentage = percentage / 100;
    return value * BigInt(decimalPercentage * 1e32) / BigInt(1e32);
  }
};
export {
  BigMath
};
//# sourceMappingURL=index.esm.js.map
